"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var CREATED = 'created', FAILED = 'failed', CREATED_CALLBACK_PREFIX = 'onCreatedPayjpToken_', FAILED_CALLBACK_PREFIX = 'onFailedPayjpToken_';
var PayjpCheckout = /** @class */ (function (_super) {
    __extends(PayjpCheckout, _super);
    function PayjpCheckout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayjpCheckout.install = function (V) {
        V.component('payjp-checkout', this);
    };
    PayjpCheckout.prototype.render = function (createElement) {
        return createElement('div', {});
    };
    PayjpCheckout.prototype.mounted = function () {
        var self = this;
        var emit = this.$emit.bind(this);
        var random = self.random || Math.random;
        function generateCallback(eventName, prefix) {
            var rand = Math.ceil(random() * 1e20).toString(0x10);
            var name = prefix + rand;
            var w = window;
            if (w[name]) {
                return generateCallback(eventName, prefix);
            }
            w[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var ret = emit.apply(void 0, [eventName].concat(args));
                try {
                    delete w[name];
                }
                finally {
                    var inputs = self.$el.getElementsByTagName('input')[0] || {};
                    return !!inputs.form && !!ret;
                }
            };
            return name;
        }
        var createdCallbackName = generateCallback(CREATED, CREATED_CALLBACK_PREFIX);
        var failedCallbackName = generateCallback(FAILED, FAILED_CALLBACK_PREFIX);
        var scriptEl = document.createElement('script');
        // https://pay.jp/docs/checkout
        var attrs = {
            src: 'https://checkout.pay.jp/',
            class: 'payjp-button',
            'data-key': this.apiKey,
            'data-payjp': this.clientId,
            'data-partial': !!this.partial,
            'data-text': this.text,
            'data-submit-text': this.submitText,
            'data-token-name': this.tokenName,
            'data-previous-token': this.previousToken,
            'data-lang': this.lang,
            'data-on-created': createdCallbackName,
            'data-on-failed': failedCallbackName,
            'data-name-placeholder': this.namePlaceholder
        };
        Object.keys(attrs).forEach(function (key) {
            var value = attrs[key];
            if (value !== undefined) {
                scriptEl.setAttribute(key, value);
            }
        });
        this.$el.appendChild(scriptEl);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true }),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "apiKey", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "clientId", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], PayjpCheckout.prototype, "partial", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "text", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "submitText", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "tokenName", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "previousToken", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: 'ja', validator: function (value) { return /^ja|en$/.test(value); } }),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "lang", void 0);
    __decorate([
        vue_property_decorator_1.Prop({}),
        __metadata("design:type", String)
    ], PayjpCheckout.prototype, "namePlaceholder", void 0);
    PayjpCheckout = __decorate([
        vue_property_decorator_1.Component
    ], PayjpCheckout);
    return PayjpCheckout;
}(vue_property_decorator_1.Vue));
exports.default = PayjpCheckout;
//# sourceMappingURL=index.js.map